import React from 'react';
import { default as getVariationsFromProps } from "@pb/utils/common/getVariationsFromProps";
import cn from 'classnames';
import styles from './HeadingLoader.module.scss';
const HeadingLoader = (props) => {
    const [variationsClassNames] = getVariationsFromProps(props, styles);
    return React.createElement("span", { className: cn(styles.container, variationsClassNames, props.className) });
};
export default HeadingLoader;
//# sourceMappingURL=HeadingLoader.js.map